import { VariantAFPopulation } from '../redux/types';

/**
 * Fields that are relevant for determining whether gnomAD frequency base data
 * has actually changed.  Only these fields influence auto-calculated arguments.
 */
const COMPARED_FIELDS: (keyof VariantAFPopulation)[] = [
  'allele_count',
  'allele_number',
  'allele_frequency',
  'homozygous',
  'hemizygous',
  'filtered_allele_frequency',
  'fafmax_faf95_max_joint',
];

/**
 * Returns `true` when there is a REAL difference between two sets of
 * gnomAD population frequency rows (before and after update).
 */
export const hasFrequencyDataChanged = (
  oldFrequencies: VariantAFPopulation[],
  newFrequencies: VariantAFPopulation[],
): boolean => {
  if (oldFrequencies.length !== newFrequencies.length) {
    return true;
  }

  return oldFrequencies.some((oldRow, index) => {
    const newRow = newFrequencies[index];
    return COMPARED_FIELDS.some(
      (field) => String(oldRow[field] ?? '') !== String(newRow[field] ?? ''),
    );
  });
};
